import type { ReactNode } from 'react';
import './AvisoDaTela.css';

export type TomDoAviso = 'ok' | 'atencao' | 'erro';

/**
 * Linha de retorno de uma ação, acima da listagem.
 *
 * `erro` é `alert` — interrompe o leitor de tela, porque a ação não aconteceu
 * e a pessoa precisa saber agora. `ok` e `atencao` são `status`: informam sem
 * atropelar quem está no meio de outra coisa.
 */
export function AvisoDaTela({
  tom,
  children,
}: {
  readonly tom: TomDoAviso;
  readonly children: ReactNode;
}) {
  return (
    <p className={`aviso-tela aviso-tela--${tom}`} role={tom === 'erro' ? 'alert' : 'status'}>
      {children}
    </p>
  );
}
